import { Typography, Box } from "@mui/material";
// import { Box,Typogra } from "@mui/system";
import ModalExpired from "./ModalExpired";
import React, { useState, useEffect } from "react";

const Countdown = ({ minutes, seconds, eventId, isPaying }) => {
  const [remainingTime, setRemainingTime] = useState(minutes * 60 + seconds);
  // console.log(isPaying)
  useEffect(() => {
    if (remainingTime <= 0) {
      return;
    }
    const timer = setInterval(() => {
      setRemainingTime((prevTime) => prevTime - 1);
    }, 1000);
    if (isPaying) {
      clearInterval(timer);
      return;
    }

    return () => {
      clearInterval(timer);
    };
  }, [isPaying]);

  const formatTime = (time) => {
    return time < 10 ? `0${time}` : `${time}`;
  };

  const displayMinutes = Math.floor(remainingTime / 60);
  const displaySeconds = remainingTime % 60;
  if (remainingTime < 0) {
    return <ModalExpired open={true} eventId={eventId} />;
  }
  return (
    <div className="countdownBox">
      <Box>
        {/* <Typography fontSize={16} fontWeight={600}>
          Complete The payment within
        </Typography> */}

        <Typography
          className="textPayment"
          fontSize={12}
          fontWeight={600}
          mb={0.5}
        >
          Complete the payment by:
        </Typography>
        <Box
          display={"flex"}
          justifyContent="space-evenly"
          width={"fit-content"}
          border={"1px solid lightgray"}
          padding={1}
          borderRadius={2}
          className={"countdownBox_inside"}
        >
          <Box
            display={"flex"}
            flexDirection="column"
            alignItems={"center"}
            // width={"54px"}
          >
            <Typography fontSize={14} fontWeight={600}>
              {formatTime(displayMinutes)}
            </Typography>
            <Typography fontSize={10} fontWeight={600}>
              MINS
            </Typography>
          </Box>
          <Typography fontSize={14} fontWeight={600} mx={1}>
            :
          </Typography>
          <Box display={"flex"} flexDirection="column" alignItems={"center"}>
            <Typography fontSize={14} fontWeight={600}>
              {formatTime(displaySeconds)}
            </Typography>
            <Typography fontSize={10} fontWeight={600}>
              SECONDS
            </Typography>
          </Box>
        </Box>
      </Box>
    </div>
  );
};

export default Countdown;
